import { createFileRoute } from "@tanstack/react-router";

import UserSettings from "@/user/components/settings/UserSettings";

export const Route = createFileRoute("/_panel/_settings/settings/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <UserSettings />;
}
